import * as React from "react";

const SvgIcnAnalyzeBold = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
        <path
            fill="currentColor"
            fillRule="evenodd"
            stroke="currentColor"
            d="M7.5 6.5H5a.5.5 0 00-.5.5v12a.5.5 0 00.5.5h9a.51.51 0 00.008 0H9.982l-.168-.007A2.5 2.5 0 017.5 17V6.5zm11.5-2h-9a.5.5 0 00-.5.5v12a.5.5 0 00.5.5h9a.5.5 0 00.5-.5V5a.5.5 0 00-.5-.5zm-7.5 6h3v5h-3v-5zm6-4v9h-3v-9h3z"
        />
    </svg>
);

export default SvgIcnAnalyzeBold;
